var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 500,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "区域名称",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["name", _vm.validatorRules.name],
                            expression: "['name', validatorRules.name]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "请输入区域名称" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "排序",
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["sort", { initialValue: 0 }],
                            expression: "['sort', { initialValue: 0 }]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, placeholder: "数字越小越靠前" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }